import type { Enums, Nullable } from "../types";

export function getEmailStateColor(state: Nullable<string>): Enums<"color"> {
	switch (state) {
		case "bounced":
			return "red";
		case "canceled":
			return "gray";
		case "clicked":
			return "blue";
		case "complained":
			return "rose";
		case "delivered":
			return "green";
		case "delivery_delayed":
			return "amber";
		case "failed":
			return "red";
		case "opened":
			return "accent";
		case "queued":
			return "slate";
		case "scheduled":
			return "indigo";
		case "sent":
			return "emerald";
		case undefined:
			return "primary";
		case null:
			return "primary";
		default:
			return "primary";
	}
}
